import { fetchForms } from './fetch-forms';
import { defaultLocaleDatasetLoader, loadTranslations, } from '../../services/load-translations';
import { INITIAL_DATA_LOADERS } from '@wix/form-fields/controller';
import { fetchAddressForms } from '../../services/fetch-address-forms';
import { hasMultilineAddress } from '../../services/has-multiline-address';
import { getUserData } from './wix-code-api';
export const getInitialData = async ({ formIds, formKind, namespace, throwWhenFormMissing, locale, localeDatasetLoader, httpClient, errorMonitor, additionalMetadata, wixCodeApi, isEditor, errorHandler, }) => {
    const [formsById, translations, tpaTranslations, userData] = await Promise.all([
        fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing,
            additionalMetadata,
            errorHandler,
        }),
        loadTranslations(locale, errorMonitor),
        {}, // loadTPATranslations(locale),
        getUserData(wixCodeApi),
    ]);
    const forms = Object.values(formsById).filter(Boolean);
    localeDatasetLoader ??= defaultLocaleDatasetLoader(forms, locale, errorMonitor);
    const localeDataset = await localeDatasetLoader();
    let addressTemplates;
    if (forms.some((f) => hasMultilineAddress(f, { excludeEcomAddress: true }))) {
        addressTemplates = await fetchAddressForms(httpClient, errorHandler);
    }
    const loaders = Object.entries(INITIAL_DATA_LOADERS).filter(([fieldType]) => forms.some((form) => form.fields?.some((field) => fieldType === field.view?.fieldType)));
    const fieldInitialData = await Promise.all(loaders.map(async ([fieldType, loader]) => {
        const formId = forms.find((form) => form.fields?.some((field) => field.view?.fieldType === fieldType))?.id;
        const result = await loader(httpClient, errorHandler, wixCodeApi, formId, isEditor);
        return [fieldType, result];
    })).then((results) => results.reduce((acc, [fieldType, result]) => {
        acc[fieldType] = result;
        return acc;
    }, {}));
    return {
        formsById,
        translations,
        tpaTranslations,
        localeDataset,
        addressTemplates,
        fieldInitialData,
        userData,
    };
};
//# sourceMappingURL=get-initial-data.js.map